<template>
  <div class="comp-full-calendar">
    <!-- header pick month -->
    <fc-header v-show="headerShow" :current-date="currentDate"
      :title-format="titleFormat"
      :first-day="firstDay"
      :month-names="monthNames"
      @change="emitChangeMonth">

      <div slot="header-left">
        <slot name="fc-header-left">
        </slot>
      </div>

      <div slot="header-right">
        <slot name="fc-header-right">
        </slot>
      </div>
    </fc-header>
    <!-- body display date day and events -->
    <fc-body :current-date="currentDate" :events="events" :month-names="monthNames"
      :week-names="weekNames" :first-day="firstDay"
      @eventclick="emitEventClick" @dayclick="emitDayClick"
      @moreclick="emitMoreClick" @calendarnumberclick="emitCalendarNumberClick">
      <div slot="body-card">
        <slot name="fc-body-card">
        </slot>
      </div>
    </fc-body>
  </div>
</template>
<script type="text/babel">
import fcBody from './components/body';
import fcHeader from './components/header';
import langSets from './dataMap/langSets';

export default {
  props: {
    headerShow: { // @author jeee12 작업관리 > header 공통 컴포넌트로 관리위해 show여부 추가
      type: Boolean,
      default: true,
    },
    events: {
      // events will be displayed on calendar
      type: Array,
      default: () => [],
    },
    lang: {
      type: String,
      default: 'ko',
    },
    selectedDate: { // @author jeee12 현재가 아닌 특정 날짜를 기준으로 calendar 최초 로드
      type: Date,
      default: new Date(),
    },
    firstDay: {
      type: Number || String,
      validator(val) {
        const res = parseInt(val, 10);
        return res >= 0 && res <= 6;
      },
      default: 0,
    },
    titleFormat: {
      type: String,
      default() {
        return langSets[this.lang].titleFormat;
      },
    },
    monthNames: {
      type: Array,
      default() {
        return langSets[this.lang].monthNames;
      },
    },
    weekNames: {
      type: Array,
      default() {
        const arr = langSets[this.lang].weekNames;
        return arr.slice(this.firstDay).concat(arr.slice(0, this.firstDay));
      },
    },
  },
  data() {
    return {
      // currentDate: new Date(),
      currentDate: this.selectedDate, // @author jeee12 현재가 아닌 특정 날짜를 기준으로 calendar 최초 로드
    };
  },
  watch: {
    selectedDate(value) {
      // @author jeee12 선택된 날짜를 기준으로 calendar 변경
      this.currentDate = value;
    },
  },
  methods: {
    emitChangeMonth(start, end, currentStart, current) {
      // console.log('currentDate 2', this.currentDate);
      this.currentDate = current;
      // console.log('currentDate 3', this.currentDate);
      this.$emit('changeMonth', start, end, currentStart);
    },
    emitEventClick(event, jsEvent, pos) {
      this.$emit('eventClick', event, jsEvent, pos);
    },
    emitDayClick(day, jsEvent) {
      this.$emit('dayClick', day, jsEvent);
    },
    emitMoreClick(day, events, jsEvent) {
      this.$emit('moreClick', day, event, jsEvent);
    },
    emitCalendarNumberClick(day, jsEvent) {
      // @author jeee12
      this.$emit('calendarNumberClick', day, jsEvent);
    },
  },
  components: {
    fcBody,
    fcHeader,
    // 'fc-body': require('./components/body'),
    // 'fc-header': require('./components/header'),
  },
};
</script>
<style lang="scss">
.comp-full-calendar {
  padding: 0;
  background: #fff;
  // max-width: 960px; // jeee12
  margin: 0 auto;
  ul,
  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/external/vue-fullcalendar/fullCalendar.vue